// Auto-generated from standalone schema 'Tool'. Do not edit.
import { z } from 'zod/v4';
export const ToolZodGenerationWarnings = [
    {
        "path": "$defs.RoleByName.propertyNames",
        "message": "Unsupported propertyNames $ref target; keys will not be validated."
    },
    {
        "path": "Tool.allOf[0].properties.intrinsicInputByRoleName.propertyNames",
        "message": "Unsupported propertyNames $ref target; keys will not be validated."
    }
];
const DescriptionSchema = z.lazy(() => z.string().min(1));
const DescriptionFacetSchema = z.lazy(() => z.object({ "description": DescriptionSchema }));
const DocumentationSpecSchema = z.lazy(() => z.object({ "name": NameSchema, "symbol": z.string().optional(), "description": DescriptionSchema }));
const JsonSchemaObjectSchema = z.lazy(() => z.object({ "$schema": z.literal("https://json-schema.org/draft/2020-12/schema") }).passthrough());
const NameSchema = z.lazy(() => z.string().min(1).regex(new RegExp("^[A-Z][a-zA-Z0-9]*$")));
const NameFacetSchema = z.lazy(() => z.object({ "name": NameSchema }));
const ResourceTypeHandleSchema = z.lazy(() => z.string().regex(new RegExp("^TYPE-.+$")));
const RoleSchema = z.lazy(() => z.object({ "resourceTypeHandle": ResourceTypeHandleSchema, "refinementSchema": JsonSchemaObjectSchema.optional() }).strict());
const RoleByNameSchema = z.lazy(() => z.record(z.string(), RoleSchema));
const RoleNameSchema = z.lazy(() => NameSchema);
const RoleSpecSchema = z.lazy(() => z.object({ "inputRoleByName": RoleByNameSchema, "outputRoleByName": RoleByNameSchema, "refinementSchema": JsonSchemaObjectSchema.optional() }).strict());
const RoleSpecFacetSchema = z.lazy(() => z.object({ "roleSpec": RoleSpecSchema }));
const ToolHandleSchema = z.lazy(() => z.string().regex(new RegExp("^TOOL-.+$")));
export const ToolSchema = z.lazy(() => z.intersection(z.intersection(z.intersection(z.intersection(z.object({ "handle": ToolHandleSchema, "templateToolHandle": ToolHandleSchema.optional(), "isTemplate": z.boolean(), "instantiationRoleSpec": RoleSpecSchema.optional(), "intrinsicInputByRoleName": z.record(z.string(), z.any()).optional() }).strict(), DocumentationSpecSchema), z.any()), z.any()), RoleSpecFacetSchema));
